(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sm-product-shopping"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sm-purchase-bar')) {
    customElements.define('sm-purchase-bar', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        this.button = this.querySelector('button');
        this.main = this.closest('main');
        if (!this.button || !this.main) return;
        this.button.addEventListener('click', () => {
          const source = this.sourceButton();
          if (source && !source.disabled) source.click();
        }, { signal: this.controller.signal });
        this.schedule = () => {
          if (this.queued) return;
          this.queued = true;
          requestAnimationFrame(() => { this.queued = false; this.update(); });
        };
        addEventListener('scroll', this.schedule, { passive: true, signal: this.controller.signal });
        addEventListener('resize', this.schedule, { signal: this.controller.signal });
        this.observer = new MutationObserver(this.schedule);
        this.observer.observe(this.main, { childList: true, characterData: true, subtree: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled'] });
        this.schedule();
      }
      sourceButton() {
        return this.main.querySelector('product-form-component button[type="submit"][name="add"]');
      }
      update() {
        if (!this.isConnected) return;
        const source = this.sourceButton();
        if (!source) { this.hidden = true; return; }
        const label = source.innerText.replace(/\s+/g, ' ').trim();
        if (this.button.textContent !== label) this.button.textContent = label;
        this.button.disabled = source.disabled || source.getAttribute('aria-disabled') === 'true';
        const rect = source.getBoundingClientRect();
        const visible = rect.height > 0 && rect.top >= 0 && rect.bottom <= innerHeight;
        this.hidden = visible || rect.height === 0 || this.button.disabled;
        this.main.querySelectorAll('.kaching-bundles__bar-main').forEach(option => {
          const title = option.querySelector('.kaching-bundles__bar-title');
          const price = option.querySelector('.kaching-bundles__bar-price');
          const subtitle = option.querySelector('.kaching-bundles__bar-subtitle');
          const existing = option.querySelector('.sm-bundle-delivery');
          const eligible = title?.textContent.trim() === '2 Pack Bundle' && price?.textContent.trim() === '$41.80';
          if (eligible && subtitle && !existing) {
            const line = document.createElement('span');
            line.className = 'sm-bundle-delivery';
            line.textContent = this.dataset.delivery;
            subtitle.append(line);
          } else if (!eligible && existing) existing.remove();
        });
      }
      disconnectedCallback() { this.controller?.abort(); this.observer?.disconnect(); }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
